import * as fromStore from './store'

const fromSignalR = {
  reducer: fromStore.reducers,
  epics: fromStore.epics,
  actions: fromStore.actions,
  STORE_ID: fromStore.STORE_ID,
}

export * from './signal-r-connection'
export * from './connection-provider'
export * from './signal-r.service'

export { SignalRState } from './store'
export { fromSignalR }



// WEBPACK FOOTER //
// ./src/modules/signal-r/index.ts